import { render, staticRenderFns } from "./FixedContentLayout.vue?vue&type=template&id=460d881b"
import script from "./FixedContentLayout.vue?vue&type=script&lang=ts"
export * from "./FixedContentLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports